import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsObjectType, VioInputModule, VioInputService } from 'vio-input';
import { ApiRequestsService } from '../../services/api-requests.service';
import { CommonFunctionService } from '../../services/common-function.service';
import { ToastrService } from 'ngx-toastr';
import { DisableWhileDirective } from '../../shared/directives/disable-while.directive';

@Component({
  selector: 'app-add-edit-device-modal',
  standalone: true,
  imports: [FormsModule, CommonModule, VioInputModule, DisableWhileDirective],
  templateUrl: './add-edit-device-modal.component.html',
  styleUrl: './add-edit-device-modal.component.scss'
})
export class AddEditDeviceModalComponent implements OnInit {
  @Input() data: any = {};
  deviceInfo: FormsObjectType = {
    config: {
      numberOfColumnsInRow: 1,
      formSubmitURL: '',
      isInvalidNoRequiredFieldSubmitted: false,
      showError: 'Inline',
      showLineBellowGroup: false,
      displayType: 'Floating',
    },
    fields: {
      _id: { dataType: 'string', inputType: 'text', groupName: '', groupHeading: '', isRequired: false, isReadOnly: true, isHidden: true, placeHolder: '', label: '', value: '', marginPading: 'mb-3', columnSize: 12, },
      deviceId: { dataType: 'string', inputType: 'text', groupName: '', groupHeading: '', isRequired: true, isReadOnly: false, isHidden: false, placeHolder: 'Enter Device Identifier', label: 'Device Identifier', value: '', marginPading: 'mb-3', columnSize: 12, },
      deviceDescr: { dataType: 'string', inputType: 'textarea', groupName: '', groupHeading: '', isRequired: true, isReadOnly: false, isHidden: false, placeHolder: 'Enter Device Description', label: 'Device Description', value: '', marginPading: 'mb-3', columnSize: 12, },
      ctName: { dataType: 'string', inputType: 'select', isReadOnly: false, isRequired: true, label: 'Configuration', placeHolder: ' ', value: "", columnSize: 12, displayFieldName: "ctName", groupName: "", valueFieldName: "ctName", options: [], marginPading: 'mb-3' },
    },
  };
  isSubmitting: boolean = false;

  getConfigurations = async () => {
    let { errorCode, errorDescription, Data } = await this.apiRequest.postAPICallWithPromise('messageconfig/getConfigurations')

    if (errorCode == this.apiRequest.NO_ERROR) {
      this.deviceInfo.fields['ctName']['options'] = Data;

    }
  }

  constructor(public ngbActiveModal: NgbActiveModal, private vioInputService: VioInputService, private apiRequest: ApiRequestsService, private common: CommonFunctionService, private toaster: ToastrService) { }
  ngOnInit(): void {

    this.getConfigurations();
    if (this.data.deviceData['_id']) {
    } else {
      this.deviceInfo.fields['deviceId']['isReadOnly'] = false;
    }
    this.common.assignObjectValuesToVioInputComponent(this.deviceInfo.fields, this.data.deviceData)

  }

  saveDevice = async () => {
    this.isSubmitting = true;
    if (!this.vioInputService.validateFormObject(this.deviceInfo.fields)) {
      console.log('Here in errors..', this.vioInputService.errorArray)
      this.isSubmitting = false;
      return;
    }
    let deviceObj = this.vioInputService.generateKeyValuePairForFormObject(this.deviceInfo.fields)
    let { errorCode, errorDescription, Data } = await this.apiRequest.postAPICallWithPromise('devices/saveDevice', { deviceData: deviceObj });
    if (errorCode == this.apiRequest.NO_ERROR) {
      this.toaster.success(`Device saved successfully.`);
      this.closeModal('Yes');
    } else {
      this.toaster.error(errorDescription);
    }
    this.isSubmitting = false;
  }

  closeModal(result: string) {
    this.ngbActiveModal.close(result);
  }


}
